import {
  NotificationBase,
  NotificationReadBatchUpdateItem,
  NotificationReadBatchUpdateResponse,
  NotificationTempMapping,
} from "../types/notification.types";
import { getTokenAsync } from "@coworker/app/src/hooks/API/getAuthToken";
import { makeHeaders } from "@coworker/app/src/components/RoomSettings/tools";
import { CORE_SERVICE_URL } from "@coworker/app/src/hooks/API/core.service";

const BASE_URL = `${CORE_SERVICE_URL}/notifications`;

export function tempMapping(item: NotificationTempMapping) {
  const { type, content, props, ...rest } = item;
  if (!content || !content.type) {
    return {
      ...rest,
      content: { type, props },
      contentType: type,
    };
  } else {
    return item;
  }
}

export const getMessageNotifications = async (storeId: string, uid: string) => {
  const token = await getTokenAsync();
  if (!token || typeof token !== "string") {
    throw new Error("Notifications: Could not get a token.");
  }
  const response = await fetch(
    `${BASE_URL}/stores/${encodeURIComponent(storeId)}/users/${encodeURIComponent(uid)}/messages`,
    {
      method: "GET",
      headers: makeHeaders(token),
    }
  );

  if (!response.ok) {
    throw new Error("Notifications: Network response was not ok.");
  }

  const json = (await response.json()) as NotificationTempMapping[];
  return json.map(tempMapping) as NotificationBase[];
};

export const setMessageNotificationAsRead = async (notificationId: string) => {
  const token = await getTokenAsync();
  if (!token || typeof token !== "string") {
    throw new Error("Could not get a token.");
  }
  const response = await fetch(
    `${BASE_URL}/messages/read/${encodeURIComponent(notificationId)}`,
    {
      method: "PUT",
      headers: makeHeaders(token),
      body: JSON.stringify({ read: true }),
    }
  );

  if (!response.ok) {
    throw new Error("Notifications: Network response was not ok.");
  }

  const json = (await response.json()) as NotificationTempMapping;
  return tempMapping(json) as NotificationBase;
};

export const setAllMessageNotificationAsRead = async (
  notificationIds: string[]
) => {
  const readAndIdList: NotificationReadBatchUpdateItem[] = notificationIds.map(
    (notificationId) => ({
      notificationId,
      read: true,
    })
  );

  const token = await getTokenAsync();
  if (!token || typeof token !== "string") {
    throw new Error("Notifications: Could not get a token.");
  }
  const response = await fetch(`${BASE_URL}/messages/read/batch`, {
    method: "PUT",
    headers: makeHeaders(token),
    body: JSON.stringify(readAndIdList),
  });

  if (!response.ok) {
    throw new Error("Notifications: Network response was not ok.");
  }

  const data = (await response.json()) as NotificationReadBatchUpdateResponse;
  data.updated.map((item) => {
    return item;
  });

  if (data.failed.length) {
    console.error(
      "Notifications: setAllMessageNotificationAsRead failed",
      JSON.stringify(data.failed)
    );
  }
  return data;
};
